import React from 'react';
import { FaVolumeUp } from 'react-icons/fa';
import Slider from 'rc-slider';
import styled from 'styled-components';

const StyledVolume = styled.div`
  position: absolute;
  width: 34px;
  height: 120px;
  display: flex;
  justify-content: center;
  transform: translateX(-40%);
  top: 5px;

  .rc-slider {
    height: 100% !important;
    margin-left: -4px;
  }
`;

const PlayerVolume = ({ volume, setVolume, isActive, toggle }) => {
  const handleVolumeChange = (value) => {
    const v = parseFloat(value);
    setVolume(v);
    localStorage.setItem('volume', v.toString());
  };

  return (
    <>
      <a
        className={`player__interaction-button waves-effect waves-button js-page-player-volume ${
          isActive ? 'js-dropdown-button' : ''
        }`}
        href="#"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          toggle();
        }}
      >
        <FaVolumeUp size={24} color="#10DB92" />
      </a>

      <div
        className={`player__interaction-content player__volume ${
          isActive ? 'js-dropdown-content' : ''
        }`}
        onClick={(e) => e.stopPropagation()} 
      >
        <div className="player__volume-track js-page-player-song-volume-track">
          <div
            className="player__volume-progress js-page-player-song-volume-progress"
            style={{ height: `${volume * 100}%`, pointerEvents: 'none' }}
          />

          {isActive && (
            <StyledVolume onClick={(e) => e.stopPropagation()}>
              <Slider
                vertical
                min={0}
                max={1}
                step={0.01}
                value={Number(volume)}
                onChange={handleVolumeChange}
                className="Catalog__volume-bar_slider"
                trackStyle={{
                  width: 6,
                  background: '#10DB92',
                  borderRadius: 10,
                }}
                railStyle={{
                  width: 6,
                  background: 'rgba(255,255,255,0.3)',
                }}
                handleStyle={{
                  background: '#10DB92',
                  border: '2px solid #fff',
                  width: 16,
                  height: 16,
                  borderRadius: '50%',
                  marginLeft: -5,
                }}
                onClick={(e) => e.stopPropagation()}
              />

              <FaVolumeUp
                size={24}
                color="#10DB92"
                style={{
                  position: 'absolute',
                  bottom: -32,
                  left: 4,
                }}
              />
            </StyledVolume>
          )}
        </div>
      </div>
    </>
  );
};

export default PlayerVolume;
